import { prefixObjectValues as pre } from '../utils';

const prefix = 'peer-reference-table';

const table = pre(
  {
    row: 'row-',
    date: 'date-sort',
    type: 'type-sort',
    name: 'name-sort',
    status: 'status-sort',
    actions: 'actions-sort',
    deleteBtn: 'delete-btn',
    addBtn: 'add-btn',
    editBtn: 'edit-btn',
    check: 'green-check',
    warning: 'red-warning',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
